import { useEffect, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { FormModel, FormStates } from '../../../models/form/form';
import { getForms, getFormsResponseModel } from '../../../services/form/FormService';

const pageSize = 5;

interface FormData {
  data: FormModel[];
  page: number;
  pageSize: number;
  totalCount: number;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useFormList = (organizationId?: string) => {
  const [id, setOrganizationId] = useState(organizationId);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [forms, setForms] = useState<getFormsResponseModel>();

  useEffect(() => {
    if (!id) {
      // TODO Set invalid properties
      return;
    }
    getFormsByPage(1, FormStates.Active);
  }, [id]);

  const getFormsByPage = async (page, state) => {
    try {
      if (id) {
        setIsLoading(true);
        const forms = await getForms(id, page, pageSize, state);
        const formsResult = forms.data as unknown as FormData;
        setCurrentPage(page);
        setTotalCount(formsResult.totalCount);
        const formsTyped: getFormsResponseModel = [];
        if (formsResult.data) {
          formsResult.data.forEach((form) => {
            formsTyped.push(form);
          });
        }

        setForms(formsTyped);
      }
    } catch (error) {
      handleError(error);
    }

    setIsLoading(false);
  };

  return { forms, setOrganizationId, isLoading, getFormsByPage, pageSize, currentPage, totalCount };
};

export default useFormList;
